import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { PlayAudio } from '../../state/engine.actions';
import { EngineState } from '../../state/engine.state';

@Component({
  selector: 'app-engine-audio',
  templateUrl: './engine-audio.component.html',
  styleUrls: ['./engine-audio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EngineAudioComponent implements OnInit, OnDestroy {
  @Select(EngineState.getPlayAudio)
  playAudio$: Observable<boolean>;

  audioVisible = false;
  ngUnsubscribe = new Subject();

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleAudioClick() {
    const playAudio = this.store.selectSnapshot(EngineState.getPlayAudio);
    this.store.dispatch(new PlayAudio(!playAudio));
  }
}
